import { Particle } from "../particle";
import { colorLerp, constant, easeOut, lerp, linearMotion, randomBetween } from "../interpolation";

/**
 * Small tan dust puffs left behind when the player walks.
 * Subtle and short-lived — just enough to suggest footsteps.
 */
export class StepDustParticle extends Particle {
	constructor(originX: number, originY: number) {
		const ttl = randomBetween(500, 650);

		// Slight random drift in any direction
		const vx = randomBetween(-0.4, 0.4);
		const vy = randomBetween(-0.5, 0.1);

		const startSize = randomBetween(0.2, 0.3);
		const endSize = randomBetween(0.4, 0.5);

		// Warm tan/brown tones
		const startColor = {
			r: randomBetween(180, 200),
			g: randomBetween(160, 175),
			b: randomBetween(120, 140),
		};
		const endColor = {
			r: randomBetween(150, 170),
			g: randomBetween(140, 155),
			b: randomBetween(110, 130),
		};

		// Spawn near the south of the cell (player's feet)
		const ox = originX + randomBetween(-0.2, 0.2);
		const oy = originY + randomBetween(0.2, 0.4);

		super(ox, oy, {
			ttl,
			size: lerp(startSize, endSize),
			opacity: easeOut(0.7, 0.3),
			color: colorLerp(startColor, endColor),
			rotation: constant(0),
			position: linearMotion(vx, vy),
		});
	}
}
